import { httpCreate } from './http';
import conf from './config';

const http = httpCreate('/srv/activityMediaLib');

export const activityMediaLib = {
	uploadVideo(params) {
		return http.get('/uploadVideo', { params });
	},
	getMediaList(activityId, data, params) {
		return http.post(`/activity/${activityId}`, data, { params });
	},
	changeTitle(id, data) {
		return http.put(`/${id}`, data);
	},
	getMediaUrl(id) {
		return http.get(`/playUrl/${id}`);
	},
	savePermanent(id, ids) {
		return http.put(`/save/${id}`, ids);
	},
	delMedia(id, ids) {
		return http.delete(`/batch/${id}`, { data: ids });
	},
	setReplay(activityId, mediaLibId) {
		return http.post(`/${activityId}/setReplay/${mediaLibId}`);
	},
	setPreset(activityId, mediaLibId) {
		return http.post(`/${activityId}/setPreset/${mediaLibId}`);
	},
	cancelPreset(activityId, mediaLibId) {
		return http.post(`/${activityId}/cancelPreset/${mediaLibId}`);
	},
	cancelReplay(activityId, mediaLibId) {
		return http.post(`/${activityId}/cancelReplay/${mediaLibId}`);
	},
	merge(activityId, ids) {
		return http.post(`/merge/${activityId}`, ids);
	},
	saveMerge(activityId, data, params) {
		return http.post(`/mergeSave/${activityId}`, data, { params });
	},
	getClipOrigin(id) {
		return http.get(`/clipInfo/${id}?photoLive=0`);
	},
	getClip(id, data, params) {
		return http.post(`/clip/${id}?photoLive=0`, data, { params });
	},
	getAllMedia(params) {
		return http.get('/getByUserId', { params });
	},
	getSpaceSize(activityId) {
		if (activityId) {
			//直播间
			return http.get(`/getSpace/${activityId}`);
		} else {
			//媒体库
			return http.get('/getSpace');
		}
	},
	getVideoList(activityId) {
		return http.get(`/activity/${activityId}`);
	},
	// 获取总容量接口
	getMediaSpace() {
		return http.get('/getTotalSpace');
	},
	getSimpleList(activityId, params) {
		return http.get(`/activity/${activityId}/simple-list`, { params });
	},
	// 删除封面图
	delCover(id) {
		return http.delete(`/delCover/${id}`);
	},
	// 创建视频下载任务
	/**
	 * @param { Number } medialLibId 视频id
	 * @returns
	 */
	createTask(medialLibId) {
		return http.post(`/download/createTask/${medialLibId}`);
	},
	// 取消视频下载任务
	/**
	 * @param { Number } taskId 任务id
	 * @returns
	 */
	cancelTask(taskId) {
		return http.post(`/download/cancelTask/${taskId}`);
	},
	// 直播间内下载列表
	getActivityTaskList(activityId) {
		return http.get(`/download/taskList/${activityId}`);
	},
	// 媒体库下载列表
	getMediaStoreTaskList() {
		return http.get('/download/taskList');
	},
	// 获取下载地址
	getDownloadUrl(mediaLibId) {
		return http.get(`/download/getUrl/${mediaLibId}`);
	},
	// 下载视频
	downloadVideoUrl(mediaLibId) {
		const host = process.env.NODE_ENV === 'development' ? conf.host : location.origin;
		return `${host}/srv/activityMediaLib/download/download/${mediaLibId}`;
	},
	// 管理员手动转码
	transcoding(videoId) {
		return http.get(`/transCode?videoId=${videoId}`);
	},
	// 获取回放配置
	getReplayConfig(activityId, params) {
		return http.get(`/replayConfig/${activityId}`, { params });
	},
	/**	设置回放配置项
	 * @param { Number } activityId 					直播间ID
	 * @param { Number } data.replayValidityType		回放有效期类型 0永久 1限时
	 * @param { Number } data.replayValidityTime		截止时间
	 * @returns
	 */
	setReplayConfig(activityId, data) {
		return http.put(`/replayConfig/${activityId}`, data);
	},
};
